import { Link } from 'react-router-dom';
import { newComics } from '@/mocks/comics';

export default function NewComicsSection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900">
              最新上架
            </h2>
            <p className="text-sm text-foreground-500 mt-1">近期上线的精选韩国漫画作品</p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
          {newComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 rounded-md text-[10px] font-medium bg-accent-500 text-background-50">
                    NEW
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <div className="flex items-center gap-1 text-background-50 text-xs">
                    <span className="w-3 h-3 flex items-center justify-center"><i className="ri-star-fill text-accent-500"></i></span>
                    <span>{comic.rating}</span>
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500">
                {comic.totalChapters}话 · {comic.author}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}